// extracted by mini-css-extract-plugin
export var input = "TextInput-module--input--f67bc";
export var label = "TextInput-module--label--3f334";
export var textInput = "TextInput-module--textInput--c22b2";
export var textarea = "TextInput-module--textarea--1b52f";